import '../ActivityActions.scss';
import React from 'react';
import { ActivityExecutionService } from '@services/actions/ActivityExecutionService';
import { useForm } from 'react-hook-form';
import ModalContainer, { IModalContainerProps } from '@molecules/ModalContainer/ModalContainer';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { useUnsavedFormInput } from '@srm/ui/hooks/useUnsavedFormInput';
import { requiredTextRules } from '@srm/ui/lib/requiredTextRules';
import { IRollbackDelegateProps } from './IRollbackDelegateProps';
import { IRollbackDelegateFormData } from './IRollbackDelegateFormData';
import TextareaControl from '@srm/ui/controls/TextareaControl';

export const RollbackDelegateModal: React.FC<IRollbackDelegateProps> = (props: IRollbackDelegateProps) => {
    const serv = new ActivityExecutionService();

    const { errorText, isBusy, isSubmitting, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        submit: (form: IRollbackDelegateFormData) =>
            serv.saveRollbackDelegate(props.actionKey, props.activityId, form?.comment),
    });

    const formState = useForm<IRollbackDelegateFormData>({
        mode: 'onBlur', // "onChange"
    });
    const hasUnsavedInput = useUnsavedFormInput(formState, { textFields: ['comment'] });

    const modalContainerProps: IModalContainerProps = {
        header: props.title,
        size: props.modalSize,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        loading: isBusy,
        closeDisabled: isSubmitting,
        hasUnsavedInput,
        onCancel: cancelClick,
        errorText: errorText,
        formMethods: formState,
        onSubmit: okClick,
        okButtonDisabled: false,
    };

    return (
        <ModalContainer {...modalContainerProps}>
            <TextareaControl
                label="Комментарий"
                readOnly={false}
                required={true}
                rules={requiredTextRules()}
                name="comment"
                rows={6}
                control={formState.control}
            />
        </ModalContainer>
    );
};
